<template>
  <div class="header">
    <p class="text_size_16 margin-right-10">
      <i class="el-icon-s-custom"></i>
      {{userInfo.userName}}
    </p>
    <el-button type="primary" size="small" @click="logout">退出登录</el-button>
  </div>
</template>
<script>
import * as api from '~/api'
import cookie from '~/utils/cookie'
export default {
  name: 'layoutContainerHeader',
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    }
  },
  methods: {
    // 注销账号
    logout () {
      api.logout().then((result) => {
        cookie.remove('T_j_cms_token')
        localStorage.removeItem('userInfo')
        this.$router.push('/login')
      }).catch((err) => {
        cookie.remove('T_j_cms_token')
        localStorage.removeItem('userInfo')
        this.$router.push('/login')
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .header {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    min-height:50px;
    padding-right: 40px;
    background-color: #ffffff;
    box-shadow:0px 0px 10px rgba(53,53,53,0.15);
    z-index: 100;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/container/header/index.vue